






















import { Component, Prop, Watch } from "vue-property-decorator";
import InputProps from "@/mixins/InputProps";
import { isMobile } from "@/lib/browserUtils";
import { getElement } from "@/lib/elementHelpers";
import BaseInput from "@/components/BaseInput";

@Component({
  name: "BaseInputTextarea",
  components: { BaseInput },
})
export default class BaseInputTextarea extends InputProps {
  @Prop({ type: Number, default: 56 })
  public readonly rowHeight!: number;

  @Prop({ type: Number, default: 2 })
  public readonly rows!: number;

  @Prop({ type: Number, default: 5 })
  public readonly maxRows!: number;

  @Prop({ type: Boolean, default: false })
  public readonly autoGrow!: boolean;

  @Prop({ type: [String, Object, Array] })
  public fieldClass!: string | Record<string, boolean> | (string | Record<string, boolean>)[];

  @Prop({
    type: String,
    default: "",
    validator: (value: string) => ["", "enter", "shiftEnter"].includes(value),
  })
  public readonly submit!: "" | "enter" | "shiftEnter";

  public contentHeight: number = 0;

  get minHeight() {
    return this.rows * (this.rowHeight - 25) + 25;
  }

  get maxHeight() {
    return this.maxRows * (this.rowHeight - 25) + 25;
  }

  get currentHeight() {
    const defaultHeight = this.rows * (this.rowHeight - 25) + 25;
    const contentHeight = this.contentHeight;
    if (!this.autoGrow) return defaultHeight;
    return Math.min(contentHeight, this.maxHeight);
  }

  public get isMobileDevice() {
    return isMobile();
  }

  public onKeydown(e: KeyboardEvent) {
    if (
      e.key !== "Enter" ||
      !this.submit ||
      (this.submit === "shiftEnter" && !e.shiftKey) ||
      (this.submit === "enter" && e.shiftKey) ||
      this.isMobileDevice
    ) {
      return;
    }
    e.preventDefault();
    this.$emit("submit");
  }

  public onKeyUp(e: KeyboardEvent) {
    if (e.key === "Enter") return;
    this.$emit("keyup", this.value);
  }

  @Watch("value", { immediate: true })
  public async onValueChange(value: string) {
    let el: HTMLInputElement | null = null;
    await this.$nextTick();
    try {
      el = getElement(this.$refs.textarea) as HTMLInputElement;
    } catch (e) {}
    if (!el) return;
    let initialValue = el.value;

    el.value = value;
    el.style.height = "";
    this.contentHeight = el.scrollHeight;
    el.value = initialValue;
    el.style.height = this.currentHeight + "px";
    this.$emit("resize", this.currentHeight);
  }

  public mounted() {
    const element = getElement<HTMLInputElement>(this.$refs.textarea);
    this.$emit("defineFocus", () => element.focus());
  }
}
